function stripNonDigits(value) {
  return String(value).replace(/[^0-9]/g, "");
}

function formatCompactDateTime(value) {
  if (!value) return "";
  const year = value.slice(0, 4);
  const month = value.slice(4, 6);
  const day = value.slice(6, 8);
  const hour = value.slice(8, 10);
  const minutes = value.slice(10, 12);
  const seconds = value.slice(12, 14);
  return `${year}-${month}-${day}${
    hour ? ` ${hour}:${minutes}:${seconds}` : ""
  }`;
}

function formatFixedMobileNumber(value) {
  return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7, 11)}`;
}

function formatHourMinute(value) {
  return `${value.slice(0, 2)}:${value.slice(2, 4)}`;
}

function formatLocalDateTimeToMinute(value) {
  if (!value) return "-";
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day} ${hour}:${minutes}`;
}

function formatNullableNumberWithCommas(value) {
  if (value === 0) return "0";
  if (!value) return "";
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function insertThousandsSeparators(value) {
  return String(value).replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
}

function formatNumberWithCommas(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const KOREAN_PRICE_DIGITS = [
  "",
  "일",
  "이",
  "삼",
  "사",
  "오",
  "육",
  "칠",
  "팔",
  "구",
];
const KOREAN_PRICE_SMALL_UNITS = ["", "십", "백", "천"];
const KOREAN_PRICE_LARGE_UNITS = [
  "",
  "만",
  "억",
  "조",
  "경",
  "해",
  "자",
  "양",
  "구",
  "간",
  "정",
  "재",
  "극",
];

function extractStrictPriceDigits(value) {
  if (value === null || value === undefined) return "";
  const source = String(value);
  const isDigits = /^\d+$/.test(source);
  const isGroupedDigits = /^\d{1,3}(?:,\d{3})+$/.test(source);
  if (!isDigits && !isGroupedDigits) return "";

  const digits = source.replace(/,/g, "").replace(/^0+/, "");
  return digits || "0";
}

function formatKoreanPriceGroup(group) {
  return group
    .split("")
    .reverse()
    .map((digit, index) => {
      if (digit === "0") return "";
      const digitText =
        digit === "1" && index > 0 ? "" : KOREAN_PRICE_DIGITS[digit];
      return `${digitText}${KOREAN_PRICE_SMALL_UNITS[index]}`;
    })
    .reverse()
    .join("");
}

function formatKoreanPriceDigits(digits) {
  if (digits === "0") return "영";

  const groups = [];
  for (let end = digits.length; end > 0; end -= 4) {
    groups.push(digits.slice(Math.max(0, end - 4), end));
  }
  if (groups.length > KOREAN_PRICE_LARGE_UNITS.length) return "";

  return groups
    .map((group, index) => {
      const groupText = formatKoreanPriceGroup(group);
      return groupText ? `${groupText}${KOREAN_PRICE_LARGE_UNITS[index]}` : "";
    })
    .reverse()
    .join("");
}

function formatKoreanPriceText(value) {
  if (value === null || value === undefined || value === "") return "";
  const segments = String(value).split("~");
  if (segments.length > 2 || !segments[0]) return "";

  const minimumDigits = extractStrictPriceDigits(segments[0]);
  if (!minimumDigits) return "";
  const minimumText = formatKoreanPriceDigits(minimumDigits);
  if (!minimumText) return "";

  if (segments.length === 1 || !segments[1]) return `${minimumText} 원`;

  const maximumDigits = extractStrictPriceDigits(segments[1]);
  if (!maximumDigits) return "";
  const maximumText = formatKoreanPriceDigits(maximumDigits);
  return maximumText ? `${minimumText} 원 ~ ${maximumText} 원` : "";
}

function formatPhoneMask(value) {
  if (!value) return value;
  const phoneNumber = stripNonDigits(value);

  if (phoneNumber.length < 3) return phoneNumber;
  if (phoneNumber.startsWith("02")) {
    if (phoneNumber.length <= 5) {
      return `${phoneNumber.slice(0, 2)}-${phoneNumber.slice(2, 5)}`;
    }
    if (phoneNumber.length <= 9) {
      return `${phoneNumber.slice(0, 2)}-${phoneNumber.slice(
        2,
        5
      )}-${phoneNumber.slice(5)}`;
    }
    return `${phoneNumber.slice(0, 2)}-${phoneNumber.slice(
      2,
      6
    )}-${phoneNumber.slice(6)}`;
  }

  if (phoneNumber.length < 8) return phoneNumber;
  if (phoneNumber.length === 8) {
    return `${phoneNumber.slice(0, 4)}-${phoneNumber.slice(4)}`;
  }
  if (phoneNumber.length <= 10) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6)}`;
  }
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    7
  )}-${phoneNumber.slice(7)}`;
}

function formatBirthdayMask(value) {
  if (!value) return value;
  const birthday = stripNonDigits(value);
  if (birthday.length < 8) return birthday;
  return `${birthday.slice(0, 8)}-${birthday.slice(8, 9)}`;
}

module.exports = {
  formatBirthdayMask,
  formatCompactDateTime,
  formatFixedMobileNumber,
  formatHourMinute,
  formatKoreanPriceText,
  formatLocalDateTimeToMinute,
  formatNullableNumberWithCommas,
  formatNumberWithCommas,
  formatPhoneMask,
  insertThousandsSeparators,
  stripNonDigits,
};
